import { Pipe, PipeTransform } from '@angular/core';
import { TranslationService } from '../services/i18n/translation.service';

@Pipe({ name: 'tr', pure: false, standalone: false })
export class TranslatePipe implements PipeTransform {
  constructor(private translation: TranslationService) {}

  transform(key: string, params?: Record<string, string | number>): string {
    return this.translation.t(key, params);
  }
}
